import * as STD                                                     from '@emersya/mpa-std-lib';
import CM                                                           from '@emersya/mpa-components-manager-lib';
import { Modal, InputButton }                                       from '@emersya/mpa-components-lib';

// import { NS as CustomerForm } from '../CustomerForm/OMSCustomerForm';

export interface IOMSCustomerFormModalComponentConfiguration extends Modal.Configuration
{
	type : 'yesNo' | 'ok';
	hasCancelButton : boolean;
};

export class OMSCustomerFormModalComponent extends Modal.Component<
	void,
	IOMSCustomerFormComponentValue
>
{
	protected override canBeClosed() : boolean {
		return false;
	};

	protected override async onOpen() {
		const _form = this.component_find('@:content.form');
		if (!(_form instanceof OMSCustomerFormComponent)) {
			this.component_throwLibraryError('', { _form });
		}
		const form : OMSCustomerFormComponent = _form;
		await form.checkAllField();
	};

	protected override onClose() {
	};

	protected override async onValidate() : Promise<IOMSCustomerFormComponentValue | void> {
		const _form = this.component_find('@:content.form');
		if (!(_form instanceof OMSCustomerFormComponent)) {
			this.component_throwLibraryError('', { _form });
		}
		const form : OMSCustomerFormComponent = _form;
		return await form.validate();
	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const abortButton = this.component_find('@:footer.abort');
		const closeButton = this.component_find('@:header.close');
		const yesButton = <InputButton.Component> this.component_find('@:footer.yes');
		await abortButton.component_disable();
		await closeButton.component_disable();
		yesButton.component_DOM.classList.add('notReady');
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IOMSCustomerFormModalComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = OMSCustomerFormModalComponent;
	export type Component = OMSCustomerFormModalComponent;
	export type Configuration = IOMSCustomerFormModalComponentConfiguration;
}
;
import manifestXMLSource                                            from './OMSCustomerFormModal.xml';
import './OMSCustomerFormModal.scss';

CM.declare({
	id :       'oms-customerModal',
	type :     OMSCustomerFormModalComponent,
	manifest : manifestXMLSource
});
import { OMSCustomerFormComponent, IOMSCustomerFormComponentValue } from '../CustomerForm/OMSCustomerForm';
